import React, { Dispatch, useRef, useEffect, useState } from 'react';
import '../App.css';
import { IInject, IInjectNode, TimeToLive } from '../interfaces';
import { useXarrow } from 'react-xarrows';
import TTLDotsDiv from './TTLDotsDiv';
import { getTranslateXY } from '../helpers/helperFunctions';

interface TTLDotsProps {
    ttl: TimeToLive
    srcNodeId: string;
    injectComponents: IInject[];
    setInjectComponents: Dispatch<IInject[]>;
    injectItem: IInject;
    setInjectItem: Dispatch<IInject>;
    turn: number;
    saveScenario: (i: IInject[]) => Promise<void>;
    setIsCOADragging: Dispatch<boolean>;
    isCOADragging: boolean;
    coaHeight: number;
    nodeHeight: string;
    setCoaClicked: Dispatch<boolean>;
    coaClicked: boolean;
}

interface INodeToCheck {
    x: number;
    y: number;
    width: number;
    height: number;
    targetNodeId: string;
    node: HTMLElement;
    srcNodeId: string;
    turn: string;
}

export class NodeToCheck {
    x: number = 0;
    y: number = 0;
    width: number = 0;
    height: number = 0;
    targetNodeId: string = '';
    node: HTMLElement = document.createElement('div');
    srcNodeId: string = '';
    turn: string = '1';
}

interface IIsOver {
    targetNodeId: string;
    isOver: boolean;
}

export class IsOver {
    targetNodeId: string = '';
    isOver: boolean = false;
}

const TTLDots: React.FC<TTLDotsProps> = ({ srcNodeId, injectComponents, setInjectComponents, injectItem, setInjectItem, turn, ttl, saveScenario, setIsCOADragging, isCOADragging, coaHeight, nodeHeight, setCoaClicked, coaClicked }) => {

    const [showDeleteTTL, setShowDeleteTTL] = useState<boolean>(false)
    const [toggleDiv, setToggleDiv] = useState<number>(1)
    const [translate, setTranslate] = React.useState<string>('');
    const [deleteLeft, setDeleteLeft] = useState<string>('');
    const [deleteTop, setDeleteTop] = useState<string>('');

    const showDeleteTTLRef = useRef<boolean>()
    useEffect(() => {
        showDeleteTTLRef.current = showDeleteTTL;
    });

    const injectItemRef = useRef<IInject>()
    useEffect(() => {
        injectItemRef.current = injectItem;
    });

    const isTTLDroppedOverNode = (ttlTransform: HTMLElement, srcNodeId: string) => {
        let isOver: boolean = false;
        let nodesToCheck: INodeToCheck[] = []
        let targetNodeId: string = '0';
        let allnodes: HTMLElement[] = []

        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[]
        }

        if (allnodes !== undefined) {
            allnodes.forEach((node: HTMLElement) => {
                let nodeToCheck: INodeToCheck = new NodeToCheck()
                nodeToCheck.x = node.getBoundingClientRect().x
                nodeToCheck.y = node.getBoundingClientRect().y
                nodeToCheck.width = node.getBoundingClientRect().width
                nodeToCheck.height = node.getBoundingClientRect().height
                nodeToCheck.targetNodeId = node.dataset.id!
                nodeToCheck.turn = node.dataset.turn!
                nodeToCheck.node = node
                nodesToCheck.push(nodeToCheck)
            })

            nodesToCheck.forEach((node: NodeToCheck) => {
                if (parseInt(node.turn) === turn) { return }
                if (ttlTransform.getBoundingClientRect().x > node.x && ttlTransform.getBoundingClientRect().x < (node.x + node.width)) {
                    if (ttlTransform.getBoundingClientRect().y > node.y && ttlTransform.getBoundingClientRect().y < (node.y + node.height)) {
                        isOver = true
                        targetNodeId = node.targetNodeId
                        node.node.parentElement!.style.border = ''
                    }
                }
            })
        }

        const isOverObj: IIsOver = new IsOver();
        isOverObj!.targetNodeId = targetNodeId
        isOverObj!.isOver = isOver
        return isOverObj;
    }

    const isTTLOverNode = (ttlTransform: HTMLElement, srcNodeId: string): boolean => {

        let nodesToCheck: INodeToCheck[] = []
        let allnodes: HTMLElement[] = []
        let isOver: boolean = false;

        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[];
        }

        if (allnodes !== undefined) {
            allnodes.forEach((node: HTMLElement) => {
                let nodeToCheck: INodeToCheck = new NodeToCheck();
                nodeToCheck.x = node.getBoundingClientRect().x
                nodeToCheck.y = node.getBoundingClientRect().y
                nodeToCheck.width = node.getBoundingClientRect().width
                nodeToCheck.height = node.getBoundingClientRect().height
                nodeToCheck.targetNodeId = node.dataset.id!
                nodeToCheck.turn = node.dataset.turn!
                nodeToCheck.node = node
                nodesToCheck.push(nodeToCheck)
            })

            nodesToCheck.forEach((node: INodeToCheck) => {
                if (parseInt(srcNodeId) < parseInt(node.srcNodeId)) {
                    if (ttlTransform.getBoundingClientRect().x > node.x && ttlTransform.getBoundingClientRect().x < (node.x + node.width)) {
                        if (ttlTransform.getBoundingClientRect().y > node.y && ttlTransform.getBoundingClientRect().y < (node.y + node.height)) {
                            if (parseInt(node.turn) === turn) {
                                isOver = false;
                                node.node.parentElement!.style.border = ''
                            } else {
                                isOver = true;
                                node.node.parentElement!.style.border = '2px solid #3F83FC'
                            }
                        
                        } else {
                            isOver = false;
                        }
                    }
                }
            })
        }

        return isOver;
    }

    const highlightAllNodes = (turnOn: boolean) => {
        let allnodes: HTMLElement[] = []
        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[];

            allnodes.forEach((node: HTMLElement) => {
                if (parseInt(srcNodeId) < parseInt(node.dataset.id!)) {
                    if (turn !== parseInt(node.dataset.turn!)) {
                        node.parentElement!.style.border = turnOn ? '2px solid #3F83FC' : '';
                    }
                }
            });
        }

    }

    const FwdXArrow = () => {
        let clickTTL: HTMLElement = document.querySelector(`#ttl${srcNodeId}${ttl.id}2`)!;
        if (clickTTL !== null) {
            if (!coaClicked) {
                isTTLOverNode(clickTTL, srcNodeId)
            }
        }
        
        const usexarrow = useXarrow()
        return (usexarrow);
    }

    const useXArrow = FwdXArrow()

    const ttlMouseDown = (ev: MouseEvent) => {
        if (ttl.nextNodeId !== '') {
            let clickTTL: HTMLElement = document.querySelector(`#ttl${srcNodeId}${ttl.id}2`)!;
            if (clickTTL !== null) {
                setDeleteLeft(getTranslateXY(clickTTL).x + 'px')
                setDeleteTop(getTranslateXY(clickTTL).y + 'px')
            }
            setTimeout(() => {
                setShowDeleteTTL(!showDeleteTTLRef.current)
            }, 250)
        } else {
            setCoaClicked(false)
            setTimeout(() => {
                setIsCOADragging(true)
            }, 0)

            window.addEventListener('mouseup', ttlMouseUp);
        }
    }

    const ttlMouseUp = () => {
        let clickTTL: HTMLElement = document.querySelector(`#ttl${srcNodeId}${ttl.id}2`)!;
    
        if (clickTTL !== null) {
            const isTTLDropped = isTTLDroppedOverNode(clickTTL, srcNodeId)
            if (isTTLDropped.isOver) {
                let newNodes: IInjectNode[] = [];

                newNodes = JSON.parse(JSON.stringify(injectItemRef.current!.nodes));

                newNodes.forEach((node: IInjectNode) => {
                    if (srcNodeId === node.id) {
                        node.timeToLive!.nextNodeId = isTTLDropped.targetNodeId;
                    }
                })

                setInjectItem({
                    ...injectItem,
                    nodes: newNodes
                });

                setInjectComponents(injectComponents.map((inject: IInject) => {
                    if (inject.id === injectItem.id) {
                        return { ...inject, nodes: newNodes };
                    } else {
                        return inject;
                    }
                }));
                setToggleDiv(toggleDiv+1)
            } else {
                setToggleDiv(toggleDiv+1)
            }
            setIsCOADragging(false)
        }
        window.removeEventListener('mouseup', ttlMouseUp);
        setTimeout(() => {
            highlightAllNodes(false);
        }, 250)
    }

    const ttl2Click = (ev: MouseEvent) => {
        setDeleteLeft('0')
        setDeleteTop('0')
        setTimeout(() => {
            setShowDeleteTTL(!showDeleteTTLRef.current)
        }, 250)
    }

    const ttl1MouseDown = (ev: MouseEvent) => {
        setCoaClicked(false)
    }

    const ttl1MouseUp = (ev: MouseEvent) => {
        setCoaClicked(true)
    }

    const createListeners = () => {
        
        let clickTTL2: HTMLElement = document.querySelector(`#ttl${srcNodeId}${ttl.id}2`)!;

        if (ttl.nextNodeId !== '') {
            const clickTTL1: HTMLElement = document.querySelector(`#ttl${srcNodeId}${ttl.id}1`)!;
            const deleteTTL: HTMLElement = document.getElementById(`deletettl${srcNodeId}${ttl.id}`)!;

            if (clickTTL1 !== null) {
                clickTTL1.removeEventListener('click', ttl2Click);
                clickTTL1.addEventListener('click', ttl2Click);
                clickTTL1.removeEventListener('mousedown', ttl1MouseDown);
                clickTTL1.addEventListener('mousedown', ttl1MouseDown);
                clickTTL1.removeEventListener('mouseup', ttl1MouseUp);
                clickTTL1.addEventListener('mouseup', ttl1MouseUp);
                deleteTTL.removeEventListener('mousedown', ttl1MouseDown);
                deleteTTL.addEventListener('mousedown', ttl1MouseDown);
                deleteTTL.removeEventListener('mouseup', ttl1MouseUp);
                deleteTTL.addEventListener('mouseup', ttl1MouseUp);
            }
        }

        if (clickTTL2 !== null) {
            clickTTL2.removeEventListener('mousedown', ttlMouseDown);
            clickTTL2.addEventListener('mousedown', ttlMouseDown);
        }
    }

    useEffect(() => {
        setToggleDiv(toggleDiv+1) 
    }, [injectItem.nodes]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setToggleDiv(toggleDiv+1)
    }, [ttl.nextNodeId]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        createListeners()
    }, [toggleDiv]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        isCOADragging ? highlightAllNodes(true) : highlightAllNodes(false)
    }, [isCOADragging]) // eslint-disable-line react-hooks/exhaustive-deps

    const deleteLine = async () => {
        let arrowSVG: HTMLElement = document.getElementById(`wrapttl${srcNodeId}${ttl.id}1`)!;
        arrowSVG.style.display = 'none'
        let newNodes: IInjectNode[] = [];

        newNodes = JSON.parse(JSON.stringify(injectItemRef.current!.nodes));
        let injectItem1: IInject = JSON.parse(JSON.stringify(injectItem));

        newNodes.forEach((node: IInjectNode) => {
            if (srcNodeId === node.id) {
                node.timeToLive!.nextNodeId = '';
            }
        })

        injectItem1.nodes = newNodes

        setShowDeleteTTL(false)

        const injUpdate = injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return injectItem1;
            } else {
                return inject;
            }
        });

        setInjectComponents(injUpdate);

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });

        
        await saveScenario(injUpdate);
        setToggleDiv(toggleDiv+1);
    }

    return (
        <>
            <TTLDotsDiv ttlId={ttl.id} srcNodeId={srcNodeId} updateXarrow={useXArrow} ttl={ttl} showDeleteTTL={showDeleteTTL} deleteLine={deleteLine} nodeHeight={nodeHeight} key={toggleDiv} translate={translate} setTranslate={setTranslate} deleteLeft={deleteLeft} deleteTop={deleteTop} />
        </>
    )

}

export default TTLDots;